import {makeStyles} from "@fluentui/react-components";

export const useToktokquizVer2Styles = makeStyles({

    main: {
      display: 'flex',
      flexDirection:'column',
      gap:'5px'
    },
    otherBtnStyle: {
        color: 'grey',
        fontSize:'small',
        textDecoration: 'underline',
        backgroundColor: 'transparent',
        border: 'none',
    },
    fixedTop: {
        position: 'fixed',
        top:0,
        left: 0,
        right: 0,
        zIndex: 30,
    },
    title: {
        width: 'fit-content',
        paddingLeft:'10px',
        paddingRight:'10px',
        paddingTop:'5px',
        paddingBottom:'5px',
        borderRadius: '20px',
        backgroundColor: 'white',
    }

});